export default "__VITE_ASSET__EnbO_$CR__"